import PropTypes from 'prop-types'
import { RdtInfringementLevels } from '../../models/rdt/rdt-infringement-levels-enum'

export const rdtInfringementLevelPropType = PropTypes.shape({
    level: PropTypes.oneOf(Object.values(RdtInfringementLevels)),
    stringCode: PropTypes.string
})
